import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface IListProgressProps {
    /** className to append */
    className?: string;
}

interface IState {

}

/**
 * Progress list wrapper.
 */
class ListProgress extends React.Component<IListProgressProps, IState> {
    static displayName: string = 'ListProgress';

    render () {
        return (
            <ul className={classNames('list-progress', this.props.className)}>
                {this.props.children}
            </ul>
        );
    }
}

export default ListProgress;
